import React, { useState } from 'react';
import styles from './EnquiryForm.module.scss';
import {baseUrl} from '../utils/utils.js';

const EnquiryForm = props => {

  const [name, setName] = useState(''); // Dharmit Dosani
  const [email, setEmail] = useState(''); // dharmitdosani@gmail.com
  const [mobile, setMobile] = useState(''); // 8082771421
  const [text, setText] = useState(''); // please send me this neckpiece
  const [btnText, setBtnText] = useState('Submit Enquiry');

  const handleNameChange = (e) => setName(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleMobileChange = (e) => setMobile(e.target.value);
  const handleTextChange = (e) => setText(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    setBtnText('Loading...');
    const data = {
      name: name,
      email: email,
      mobile: mobile,
      inquiry: text,
      product_code: props.productCode
    };
    const options = {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      mode: 'no-cors'
    };

    // fetch('http://diamour.in/sendmail/', options)
    fetch(baseUrl('api/send-email/', true), options)
      .then(response => response.text())
      .then(result => setBtnText('Submitted'), error => setBtnText('Some error occurred'))
      .catch(error => setBtnText('Some error occurred'));
  };

  const formClass = props.productCode ? '' : 'homepage';

  return (
    <form onSubmit={handleSubmit} className={styles[formClass]}>
      <input type="text" required value={name} onChange={handleNameChange} placeholder="e.g. Tom Cruise" />
      <input type="email" required value={email} onChange={handleEmailChange} placeholder="e.g. example@gmail.com" />
      <input type="tel" required value={mobile} onChange={handleMobileChange} placeholder="e.g. 8888888888" pattern="[6-9]{1}[0-9]{9}" />
      <textarea value={text} onChange={handleTextChange} placeholder="Enter your query here" />
      <input type="submit" value={btnText} className={styles.submitButton} />
    </form>
  );
};

export default EnquiryForm;
